import { render, staticRenderFns } from "./FilterCheckboxes.vue?vue&type=template&id=20644709&scoped=true"
import script from "./FilterCheckboxes.vue?vue&type=script&lang=js"
export * from "./FilterCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./FilterCheckboxes.vue?vue&type=style&index=0&id=20644709&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20644709",
  null
  
)

export default component.exports